import { render, staticRenderFns } from "./IndexProductScroll.vue?vue&type=template&id=217eaec9&scoped=true&"
import script from "./IndexProductScroll.vue?vue&type=script&lang=js&"
export * from "./IndexProductScroll.vue?vue&type=script&lang=js&"
import style0 from "./IndexProductScroll.vue?vue&type=style&index=0&id=217eaec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217eaec9",
  null
  
)

export default component.exports